import { api_Key } from "./Constants/Constants"

export const Orginals = `discover/tv?api_key=${api_Key}&with_networks=213`
export const Action = `discover/movie?api_key=${api_Key}&with_genres=28`
export const ComedyMovies = `discover/movie?api_key=${api_Key}&with_genres=35`
export const HorrorMovies = `discover/movie?api_key=${api_Key}&with_genres=27`
export const RomanceMovies = `discover/movie?api_key=${api_Key}&with_genres=10749`
export const search = `search/multi?api_key=${api_Key}&query=`




